import Vue from 'vue';
import {
    UPDATE_SECTION,
    REMOVE_SECTION,
    SCROLL_TO_SECTION,
    UPDATE_TITLE_SECTION,
    REMOVE_TITLE_SECTION,
} from 'vue/vuex/mutation-types';

import * as getters from './getters';
import * as actions from './actions';


/**
 * The mutations available in the module
 */
const mutations = {
    [UPDATE_SECTION](state, { section }) {
        const idx = state.sections.findIndex(item => item.position === section.position);

        if (~idx) {
            state.sections.splice(idx, 1, section);
        } else {
            state.sections.push(section);
        }
    },
    [REMOVE_SECTION](state, { section }) {
        const idx = state.sections.findIndex(item => item.position === section.position);

        if (~idx) {
            state.sections.splice(idx, 1);
        }
    },
    [SCROLL_TO_SECTION](state, { anchor }) {
        if (!anchor) {
            return;
        }

        const $el = document.getElementById(anchor);

        if ($el) {
            $el.scrollIntoView(true);
        }
    },
    [UPDATE_TITLE_SECTION](state, { section }) {
        Vue.set(state, 'titleSection', section);
    },
    [REMOVE_TITLE_SECTION](state, { section }) {
        if (state.titleSection.uuid === section.uuid) {
            Vue.set(state, 'titleSection', null);
        }
    },
};

/**
 * The state of the module
 */
const state = {
    titleSection: null,
    sections: [],
};


export default {
    actions,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/section-nav/index.js